import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class CommunicationService {
  private subjectAddEntity = new Subject<any>();
  private subjectErrorOnLogin = new Subject<any>();
  private subjectRefreshToken = new Subject<any>();
  private subjectSideBarStatus = new Subject<boolean>();

  constructor() {}

  sendSideBarStatus(status: boolean) {
    this.subjectSideBarStatus.next(status);
  }

  getSideBarStatus() {
    return this.subjectSideBarStatus.asObservable();
  }

  sendAddEntity() {
    this.subjectAddEntity.next();
  }

  getAddEntity() {
    return this.subjectAddEntity.asObservable();
  }

  sendRefreshToken() {
    this.subjectRefreshToken.next();
  }

  getRefreshToken() {
    return this.subjectRefreshToken.asObservable();
  }

  sendErrorOnLogin() {
    this.subjectErrorOnLogin.next();
  }

  getErrorOnLogin() {
    return this.subjectErrorOnLogin.asObservable();
  }
}
